{
  "newTitle": "Bagong post",
  "editTitle": "I-edit ang post",
  "lastEdited": "Huling binago {date}",
  "contributorReadOnly": "Mga sariling draft lang ang mae-edit ng contributor. Hilingin sa isang editor na baguhin ang post na ito.",
  "archivedTitle": "Naka-archive ang post na ito. Ibalik ito para ma-edit.",
  "unarchive": "Ibalik bilang draft",
  "unarchivedToast": "Naibalik bilang draft.",
  "returnedTitle": "May pinababago ang isang editor",
  "pendingTitle": "Naghihintay ng pag-apruba",
  "pendingEditorBody": "Ipinadala ito ni {name} para aprubahan. Suriin ito, saka ilathala o ibalik na may tala.",
  "pendingContributorBody": "Susuriin ito ng isang editor. Puwede mo pa rin itong baguhin.",
  "cancelledTitle": "Kinansela ang event na ito",
  "sectionType": "Uri ng post",
  "typeAnnouncementHint": "Paalala o abiso",
  "typeScheduleHint": "Mangyayari sa isang petsa, puwedeng umuulit",
  "typeProgramHint": "Aktibidad na puwedeng salihan o pagparehistruhan",
  "sectionContent": "Ano",
  "title": "Pamagat",
  "titleHint": "Maikli at malinaw, hal. \"Libreng bakuna kontra rabies\".",
  "titleRequired": "Maglagay ng pamagat na hindi bababa sa 3 character.",
  "category": "Kategorya",
  "noCategory": "Walang kategorya",
  "body": "Mga detalye",
  "bodyHint": "Ang kailangang malaman ng residente: ano ang dadalhin, sino ang puwede, bayad.",
  "formatting": "Pag-format",
  "bold": "Bold",
  "italic": "Italic",
  "underline": "Salungguhit",
  "heading": "Heading",
  "bulletList": "Listahang may bullet",
  "numberedList": "Listahang may numero",
  "quote": "Sipi",
  "link": "Link",
  "linkPrompt": "Address ng link (iwanang blangko para alisin ang link)",
  "undo": "I-undo",
  "redo": "I-redo",
  "cover": "Cover na larawan",
  "coverHint": "Opsyonal. Lalabas sa post at kapag ibinahagi ang link sa Facebook.",
  "coverAlt": "Preview ng cover na larawan",
  "addCover": "Magdagdag ng cover",
  "replaceCover": "Palitan",
  "removeCover": "Alisin",
  "uploading": "Ina-upload…",
  "attachments": "Mga attachment",
  "attachmentsHint": "PDF o larawan, hanggang 10 file na tig-2 MB (hal. form o alituntunin).",
  "addAttachment": "Magdagdag ng file",
  "attachmentName": "Pangalan ng attachment {n}",
  "removeAttachment": "Alisin ang {name}",
  "image": "Larawan",
  "sectionWhen": "Kailan",
  "timingMode": "Mga petsa",
  "timingSingle": "Isang petsa",
  "timingSessions": "Ilang petsa o oras",
  "allDay": "Buong araw",
  "starts": "Magsisimula",
  "ends": "Matatapos",
  "endsHint": "Opsyonal. Parehong araw kung oras lang ang ilalagay.",
  "endsAllDayHint": "Opsyonal, para sa event na ilang araw.",
  "repeats": "Pag-ulit",
  "repeatFreq": "Gaano kadalas",
  "repeatNone": "Hindi umuulit",
  "repeatDaily": "Araw-araw",
  "repeatWeekly": "Lingguhan",
  "repeatMonthly": "Buwanan",
  "every_days": "Tuwing ilang araw",
  "every_weeks": "Tuwing ilang linggo",
  "every_months": "Tuwing ilang buwan",
  "onDays": "Sa mga araw na ito",
  "day_MO": "Lun",
  "day_TU": "Mar",
  "day_WE": "Miy",
  "day_TH": "Huw",
  "day_FR": "Biy",
  "day_SA": "Sab",
  "day_SU": "Lin",
  "monthlyOn": "Buwan-buwan tuwing",
  "monthlyDay": "Ika-{day} ng buwan",
  "monthlyNth": "Parehong araw ng linggo bawat buwan",
  "whichWeek": "Alin",
  "sameWeekday": "Gagamitin ang araw ng petsa ng simula ({day}).",
  "ordinal_1": "Una",
  "ordinal_2": "Ikalawa",
  "ordinal_3": "Ikatlo",
  "ordinal_4": "Ikaapat",
  "ordinal_last": "Huli",
  "repeatEnds": "Matatapos",
  "endsNever": "Walang katapusan",
  "endsOn": "Sa isang petsa",
  "endsAfter": "Pagkatapos ng ilang beses",
  "lastDate": "Huling petsa",
  "times": "Ilang beses",
  "repeatSummary": "Buod:",
  "repeatNeedsStart": "Ilagay muna ang petsa ng simula.",
  "sessions": "Mga petsa at oras",
  "sessionsHint": "Pipili ng isa ang residente sa pagpaparehistro. Puwedeng may sariling bilang ng slot ang bawat isa.",
  "noSessions": "Wala pang petsa.",
  "sessionN": "Petsa {n}",
  "sessionLabel": "Label",
  "sessionLabelPlaceholder": "hal. Umagang batch",
  "startTime": "Simula",
  "endTime": "Tapos",
  "slotCapacity": "Mga slot",
  "noLimit": "Walang limit",
  "endAfterStart": "Dapat mas huli ang oras ng tapos kaysa sa simula.",
  "addSession": "Magdagdag ng petsa o oras",
  "duplicateSession": "Kopyahin ang petsa {n}",
  "removeSession": "Alisin ang petsa {n}",
  "removeSessionWithRegs": "{count} tao ang nakarehistro sa petsang ito. Kapag inalis, makakansela ito at aabisuhan sila. Ituloy?",
  "cancelSession": "Kanselahin ang petsang ito (aabisuhan ang mga nagparehistro)",
  "registeredInSession": "{count} nakarehistro",
  "sectionWhere": "Saan",
  "venueName": "Lugar",
  "venuePlaceholder": "hal. Municipal Gymnasium",
  "venueBarangay": "Barangay ng lugar",
  "noBarangay": "Hindi nakatakda",
  "venueAddress": "Address o direksyon",
  "mapPin": "Pin sa mapa",
  "mapPinHint": "I-drag ang pin o i-tap ang mapa. Magkakaroon ang mga residente ng button na \"Kunin ang direksyon\".",
  "addPin": "Maglagay ng pin sa mapa",
  "addPinHint": "Opsyonal. Para makakuha ng direksyon ang mga residente.",
  "removePin": "Alisin ang pin",
  "sectionAudience": "Para kanino",
  "audienceTown": "Buong bayan",
  "audienceBarangays": "Piling barangay",
  "chooseBarangays": "Mga barangay",
  "eligibility": "Sino ang puwedeng sumali",
  "eligibilityHint": "Opsyonal, hal. \"Senior citizen 60 pataas\" o \"Rehistradong magsasaka (RSBSA)\".",
  "sectionRegistration": "Pagpaparehistro",
  "takeRegistrations": "Tumanggap ng rehistro sa app",
  "takeRegistrationsHint": "Ilang tap lang ang pagpaparehistro ng residente at may QR ticket sila. Hindi na kailangan ng Google Forms.",
  "formFields": "Mga tanong sa form",
  "formFieldsHint": "Ang pangalan, mobile at iba pang detalye sa profile ay kusang pupunan mula sa account ng residente.",
  "fromProfile": "Pupunan mula sa profile ng residente",
  "fieldLabel": "Label",
  "requiredField": "Kailangan",
  "choices": "Mga pagpipilian",
  "choicesHint": "Isang pagpipilian bawat linya.",
  "moveUp": "Itaas ang {name}",
  "moveDown": "Ibaba ang {name}",
  "removeField": "Alisin ang {name}",
  "consentField": "Pahintulot sa privacy",
  "consentFieldHint": "Laging kasama (Data Privacy Act, RA 10173).",
  "addField": "Magdagdag ng tanong",
  "chooseField": "Pumili ng tanong na idadagdag",
  "builtInFields": "Mula sa profile ng residente",
  "customFields": "Sariling tanong",
  "kind_name": "Buong pangalan",
  "kind_mobile": "Mobile number",
  "kind_email": "Email",
  "kind_barangay": "Barangay",
  "kind_address": "Address",
  "kind_birthdate": "Petsa ng kapanganakan",
  "kind_age": "Edad",
  "kind_sex": "Kasarian",
  "kind_rsbsa": "RSBSA number",
  "kind_senior_pwd_id": "ID number ng senior citizen / PWD",
  "kind_school": "Paaralan",
  "kind_companions": "Bilang ng kasama",
  "kind_text": "Maikling sagot",
  "kind_dropdown": "Dropdown",
  "kind_checkbox": "Checkbox",
  "kind_file": "Pag-upload ng file",
  "kindType_text": "Maikling sagot",
  "kindType_dropdown": "Dropdown (pumili ng isa)",
  "kindType_checkbox": "Checkbox (oo / hindi)",
  "kindType_file": "Pag-upload ng file (larawan o PDF)",
  "capacity": "Mga slot",
  "capacityHint": "Iwanang blangko kung walang limit. May slot din ang bawat kasama.",
  "totalCapacity": "Kabuuang slot",
  "totalCapacityHint": "Opsyonal na limit sa lahat ng petsa. Puwede ring may sariling limit ang bawat petsa.",
  "cancelCutoff": "Huling oras ng pagkansela (oras)",
  "cancelCutoffHint": "Puwedeng magkansela ang residente hanggang ganitong oras bago magsimula. 0 = anumang oras.",
  "opens": "Magbubukas ang rehistro",
  "opensHint": "Iwanang blangko para magbukas pagkalathala.",
  "closes": "Magsasara ang rehistro",
  "closesHint": "Iwanang blangko para bukas hanggang sa event.",
  "waitlist": "Waitlist kapag puno",
  "waitlistHint": "Papasok sa waitlist ang mga tao at kusang aakyat kapag may nagkansela.",
  "approval": "Aprubahan ang bawat rehistro",
  "approvalHint": "Maghihintay ang mga rehistro na aprubahan o tanggihan ng editor (hal. scholarship).",
  "onePerAccount": "Isang rehistro bawat account",
  "onePerAccountHint": "I-off kung puwedeng iparehistro ng isang tao ang iba (hal. kapamilya).",
  "smsReminders": "SMS na paalala sa araw bago",
  "smsRemindersHint": "Magte-text din sa mga nagbigay ng mobile number.",
  "smsNotConfigured": "Hindi pa naka-set up ang SMS, kaya sa app notification lang ang paalala.",
  "sectionPublishing": "Paglalathala",
  "publishAt": "Ilathala sa",
  "publishAtHint": "Iwanang blangko para ilathala agad.",
  "expiresAt": "Itago pagkatapos ng",
  "expiresAtHint": "Opsyonal. Mawawala ang post sa feed pagkatapos ng petsang ito.",
  "pinned": "I-pin sa itaas",
  "pinnedHint": "Mananatili sa itaas ng pahina ng opisina at ng feed.",
  "urgent": "Agarang abiso sa buong bayan",
  "urgentHint": "Unang makikita ng lahat, sa kulay ng emergency. Gamitin lang sa tunay na agarang abiso.",
  "history": "Kasaysayan ng pagbabago",
  "edited": "Binago",
  "scheduleChangedBadge": "Nagbago ang petsa o lugar",
  "willNotify": "Binago mo ang petsa, oras o lugar. Aabisuhan ang lahat ng nakarehistro kapag nag-save ka.",
  "saveDraft": "I-save ang draft",
  "submitForApproval": "Ipadala para aprubahan",
  "publish": "Ilathala",
  "schedulePublish": "Iiskedyul",
  "saveChanges": "I-save ang mga pagbabago",
  "fixErrors": "Pakiayos ang mga naka-highlight na field.",
  "savedToast": "Na-save.",
  "submittedToast": "Naipadala para aprubahan.",
  "publishedToast": "Nailathala. Inaabisuhan na ang mga follower.",
  "scheduledToast": "Nakaiskedyul. Ilalathala ito sa petsang itinakda mo.",
  "cancelEvent": "Kanselahin ang event",
  "cancelEventTitle": "Kanselahin ang event na ito?",
  "cancelEventLead": "Makikita pa rin ang post na may markang \"Kanselado\", at aabisuhan ang lahat ng nakarehistro kasama ang iyong dahilan.",
  "cancelReason": "Dahilan",
  "cancelReasonRequired": "Magbigay ng maikling dahilan na makikita ng mga residente.",
  "confirmCancelEvent": "Kanselahin at abisuhan",
  "cancelledToast": "Kinansela ang event. Inaabisuhan na ang mga nagparehistro.",
  "archive": "I-archive",
  "confirmArchive": "I-archive ang post na ito? Mawawala ito sa feed pero mananatili sa inyong record.",
  "archivedToast": "Na-archive.",
  "deleteDraft": "Burahin ang draft",
  "confirmDelete": "Permanenteng burahin ang draft na ito?",
  "deletedToast": "Nabura ang draft.",
  "alwaysRequired": "Laging kailangan dito."
}
